/**
 * Created by pony.ma@nirvana-info on .
 */

import store from '@/store'
import config from '@/config'
import GeoZip from '@/pages/order/GeoZip'
import GeoZipRange from '@/pages/order/GeoZipRange'
import GeoZipPaste from '@/pages/order/GeoZipPaste'
import GeoZipMap from '@/pages/order/GeoZipMap'
import GeoRadiusClosX from '@/pages/order/GeoRadiusClosX'
import GeoStateMap from '@/pages/order/GeoStateMap'
import GeoStateList from '@/pages/order/GeoStateList'
import GeoState from '@/pages/order/GeoState'
import GeoPolygon from '@/pages/order/GeoPolygon'
import GeoRadius from '@/pages/order/GeoRadius'
import GeoCounty from '@/pages/order/GeoCounty'
import GeoTotalUsa from '@/pages/order/GeoTotalUsa'
import GeoMetroArea from '@/pages/order/GeoMetroArea'
import GeoCity from '@/pages/order/GeoCity'
import GeoCongressionalDistrict from '@/pages/order/GeoCongressionalDistrict'
import GeoMoreArea from '@/pages/order/GeoMoreArea'
import GeoSCFCode from '@/pages/order/GeoSCFCode'

import GeoSLCCount from '@/pages/order/GeoSLCCount'
import DemoAudiencePropensities from '@/pages/order/DemoAudiencePropensities'
import DemoSearch from '@/pages/order/DemoSearch'
import DemoDemographics from '@/pages/order/DemoDemographics'
import DemoIntrestsPurchasing from '@/pages/order/DemoIntrestsPurchasing'
import DemoQuickPick from '@/pages/order/DemoQuickPick'
import DemoBusinessQuickPick from '@/pages/order/DemoBusinessQuickPick'
import DemoSuppression from '@/pages/order/DemoSuppression'
import DemoBusinessType from '@/pages/order/DemoBusinessType'
import Summary from '@/pages/order/Summary'
import Payment from '@/pages/order/PaymentSummary'

import DemoResidentOccupantList from '@/pages/order/DemoResidentOccupantList'

import Success from '@/pages/order/Success'

export default [
  {
    name: 'geo-zip',
    path: 'geo/zip',
    component: GeoZip,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-zipRange',
    path: 'geo/zipRange',
    component: GeoZipRange,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-zipPaste',
    path: 'geo/zipPaste',
    component: GeoZipPaste,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-state',
    path: 'geo/state',
    component: GeoState,
    meta: {
      title: 'Order Leads',
      keepUnAlive: true
    }
  },
  {
    name: 'geo-stateMap',
    path: 'geo/stateMap',
    component: GeoStateMap,
    meta: {
      title: 'Order Leads',
      keepUnAlive: true
    }
  },
  {
    name: 'geo-stateList',
    path: 'geo/stateList',
    component: GeoStateList,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-polygon',
    path: 'geo/polygon',
    component: GeoPolygon,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-radius',
    path: 'geo/radius',
    component: GeoRadius,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-city',
    path: 'geo/city',
    component: GeoCity,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-county',
    path: 'geo/county',
    component: GeoCounty,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-metroArea',
    path: 'geo/metroArea',
    component: GeoMetroArea,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-congressionalDistrict',
    path: 'geo/congressionalDistrict',
    component: GeoCongressionalDistrict,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-moreArea',
    path: 'geo/moreArea',
    props: true,
    component: GeoMoreArea,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-totalUSA',
    path: 'geo/totalUSA',
    props: true,
    component: GeoTotalUsa,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-zipSelectMap',
    path: 'geo/zipSelectMap',
    props: true,
    component: GeoZipMap,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo-Closex',
    path: 'geo/Closex',
    props: true,
    component: GeoRadiusClosX,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'geo',
    path: 'geo',
    redirect: to => {
      if (store.getters['config/checkDatasource'](to.params.listType)) {
        if (store.state.site.lastGeoTab) {
          return {name: 'geo-' + store.state.site.lastGeoTab, query: to.query}
        }
        return {name: 'geo-' + store.state.config.datasource[to.params.listType].geoTabs[0], query: to.query}
      } else {
        return {name: 'landing', query: to.query}
      }
    }
  },
  {
    name: 'demo-multiCount',
    path: 'demo/multiCount',
    props: true,
    component: GeoSLCCount,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-audiencePropensities',
    path: 'demo/audiencePropensities',
    props: true,
    component: DemoAudiencePropensities,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-demoDemographics',
    path: 'demo/demoDemographics',
    props: true,
    component: DemoDemographics,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-intrestsPurchasing',
    path: 'demo/intrestsPurchasing',
    props: true,
    component: DemoIntrestsPurchasing,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-quickPicks',
    path: 'demo/quickPicks',
    props: true,
    component: DemoQuickPick,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-businessType',
    path: 'demo/businessType',
    props: true,
    component: DemoBusinessType,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-businessQuickPicks',
    path: 'demo/businessQuickPicks',
    props: true,
    component: DemoBusinessQuickPick,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-suppression',
    path: 'demo/suppression',
    props: true,
    component: DemoSuppression,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-search',
    path: 'demo/search',
    props: true,
    component: DemoSearch,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo-residentOccupantList',
    path: 'demo/residentOccupantList',
    props: true,
    component: DemoResidentOccupantList,
    meta: {
      title: 'Order Leads'
    }
  },
  {
    name: 'demo',
    path: 'demo',
    redirect: to => {
      if (store.getters['config/checkDatasource'](to.params.listType)) {
        if (store.state.site.lastDemoTab) {
          return {name: 'demo-' + store.state.site.lastDemoTab, query: to.query}
        } else {
          return {name: 'demo-' + store.state.config.datasource[to.params.listType].demoTabs[0], query: to.query}
        }
      } else {
        return {name: 'landing', query: to.query}
      }
    }
  },
  {
    name: 'summary',
    path: 'summary',
    component: Summary,
    meta: {
      title: 'Order Leads',
      isPage: true,
      keepUnAlive: true
    },
    beforeEnter: (to, from, next) => {
      if (!config.dev.isAuth) {
        next()
        return false
      }
      if (!store.getters['config/checkDatasource'](to.params.listType)) {
        next({name: 'landing', query: to.query})
        return false
      }

      if (['success', 'summary'].indexOf(store.state.order.CurrentStep) === -1) {
        next({name: 'order', params: to.params, query: to.query})
        return false
      }
      next()
    }
  },
  {
    name: 'payment',
    path: 'payment',
    component: Payment,
    meta: {
      title: 'Order Leads',
      isPage: true,
      keepUnAlive: true
    },
    beforeEnter: (to, from, next) => {
      if (!config.dev.isAuth) {
        next()
        return false
      }
      if (!store.getters['config/checkDatasource'](to.params.listType)) {
        next({name: 'landing', query: to.query})
        return false
      }

      if (['success', 'payment','summary'].indexOf(store.state.order.CurrentStep) === -1) {
        next({name: 'order', params: to.params, query: to.query})
        return false
      }
      next()
    }
  },
  {
    name: 'success',
    path: 'success',
    component: Success,
    meta: {
      title: 'Order Leads',
      isPage: true,
      keepUnAlive: true
    },
    beforeEnter: (to, from, next) => {
      if (!config.dev.isAuth) {
        next()
        return false
      }

      if (!store.getters['config/checkDatasource'](to.params.listType)) {
        next({name: 'landing'})
        return false
      }

      if (['success'].indexOf(store.state.order.CurrentStep) === -1) {
        next({name: 'order', params: to.params})
        return false
      }
      next()
    }
  },
  {
    name: 'geo-SCFCode',
    path: 'geo/SCFCode',
    props: true,
    component: GeoSCFCode,
    meta: {
      title: 'Order Leads'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/orderRoutes.js